import React from "react";
import Layout from "../layouts/Default";
import useApi from "../hooks/useApi";
import fetchApi from "../fetchApi";
import NotFound from "../pages/404";
import Text from "../components/typography/Text";
import Button from "../components/buttons/Button";
import MediumArticle from "../components/mediumArticles/MediumArticle";

const PER_PAGE = 6; // 6

const PastProjects = () => {
  const [pageIndex, setPageIndex] = React.useState(1);
  const [pagesCount, setPagesCount] = React.useState(1);
  const [projects, setProjects] = React.useState([]);
  const { data, loading } = useApi("/pages?slug=showcase");
  const [page] = data ? data : [];

  React.useEffect(() => {
    const fetch = async () => {
      try {
        const {
          data: fetchedProjects,
          headers: [totalPages],
        } = await fetchApi(
          `/past_project?per_page=${PER_PAGE}&page=${pageIndex}`,
          {},
          true,
          ["X-WP-TotalPages"]
        );
        if (totalPages) setPagesCount(totalPages);
        if (Array.isArray(fetchedProjects)) setProjects(fetchedProjects);
        else setPageIndex(pageIndex - 1);
      } catch (error) {
        console.error(error);
      }
    };
    if (pageIndex > 0) fetch();
  }, [pageIndex]);

  if (!page && !loading) return <NotFound />;
  return (
    <Layout title={page ? page.title.rendered : "Showcase"}>
      {page && (
        <div className="pPastProjects">
          <div className="pPastProjects_infos">
            <h1>{page.title.rendered}</h1>
            <p
              className="text -big"
              dangerouslySetInnerHTML={{ __html: page.content.rendered }}
            />
            <Button
              orange
              icon="medium"
              iconSize="20px"
              rounded
              outlined
              onClick={() => window.open(page.btn_link, "_blank")}
            >
              {page.btn_txt}
            </Button>
          </div>
          <div className="pPastProjects_list">
            {projects &&
              projects.map((project) => (
                <MediumArticle {...project} key={project.id} />
              ))}
          </div>
          {pagesCount > 1 && (
            <div className="oPager_bottom">
              <div className="oPager_buttons">
                {pageIndex > 1 && (
                  <Button arrowLeft onClick={() => setPageIndex(pageIndex - 1)}>
                    Previous page
                  </Button>
                )}
                {pageIndex < pagesCount && (
                  <Button
                    arrowRight
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next page
                  </Button>
                )}
              </div>
              <div className="oPager_count">
                <Text>
                  <div className="oPager_index">{pageIndex}</div> out of{" "}
                  {pagesCount}
                </Text>
              </div>
            </div>
          )}
        </div>
      )}
    </Layout>
  );
};

export default PastProjects;
